import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connectRange } from 'react-instantsearch/connectors';
import Rheostat from 'rheostat';

import './ConnectedRange.css';

class Range extends Component {
    static propTypes = {
        min: PropTypes.number,
        max: PropTypes.number,
        currentRefinement: PropTypes.object,
        refine: PropTypes.func.isRequired,
        canRefine: PropTypes.bool.isRequired,
        formatValue: PropTypes.func.isRequired,
    };

    state = { currentValues: { min: this.props.min, max: this.props.max } };

    componentWillReceiveProps(sliderState) {
        if (sliderState.canRefine) {
            this.setState({
                currentValues: {
                    min: sliderState.currentRefinement.min,
                    max: sliderState.currentRefinement.max,
                },
            });
        }
    }

    onValuesUpdated = sliderState => {
        this.setState({
            currentValues: {
                min: sliderState.values[0],
                max: sliderState.values[1],
            },
        });
    };

    onChange = sliderState => {
        if (
            this.props.currentRefinement.min !== sliderState.values[0] ||
            this.props.currentRefinement.max !== sliderState.values[1]
        ) {
            this.props.refine({
                min: sliderState.values[0],
                max: sliderState.values[1],
            });
        }
    };

    render() {
        const { min, max, currentRefinement, formatValue } = this.props;
        const { currentValues } = this.state;

        const formattedValues = {
            min: formatValue(currentValues.min),
            max: formatValue(currentValues.max),
        };

        return min !== max
            ? <div className="ConnectedRange">
                  <div className="ConnectedRange--rheostat-wrap">
                      <Rheostat
                          min={min}
                          max={max}
                          values={[
                              currentRefinement.min,
                              currentRefinement.max,
                          ]}
                          onChange={this.onChange}
                          onValuesUpdated={this.onValuesUpdated}
                      />
                  </div>

                  <div className="values">
                      <div>
                          {formattedValues.min}
                      </div>
                      <div>
                          {formattedValues.max}
                      </div>
                  </div>
              </div>
            : null;
    }
}

const ConnectedRange = connectRange(Range);

export default ConnectedRange;



// WEBPACK FOOTER //
// ./src/components/ConnectedRange/ConnectedRange.js